var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"member-stack"},[_vm._l((_vm.shown),function(m){return _c('MemberAvatar',{key:m.id,staticClass:"stack-item",attrs:{"member":m,"size":_vm.size}})}),(_vm.rest > 0)?_c('span',{staticClass:"stack-more"},[_vm._v("+"+_vm._s(_vm.rest))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }